import moment from "moment";
import React, { useState } from "react";
import { formattedAmount } from "../../../utils/helpers/Functions.helper";
import { toast } from "react-toastify";
import OrderApi, { foodOrderApi } from "../../../apis/order.apis";

const AssignOrderModal = ({
  isAssignModal,
  setIsAssignModal,
  fetchAllData,
  itemData,
  allDeliveryMan,
  deliveryBusiness,
}) => {
  const [showManualAssign, setShowManualAssign] = useState(false);
  const [showAutoAssign, setShowAutoAssign] = useState(false);
  const [isDeliveryManID, setDeliveryManID] = useState("");
  const [autoAssignRange, setAutoAssignRange] = useState("5");
  const totalCancelledPrice = 0;
  const totalCancelledDeliveryFee = 0;
  const orderDetailId = itemData?.orderDetails?.[0]?._id || null;
  console.log("itemData:",itemData?.orderDetails[0]._id  );

  console.log("allDeliveryMan:", allDeliveryMan);

  const vendorDetails =
    deliveryBusiness === "Ecommerce"
      ? itemData.orderDetails[0].vendor
      : itemData?.vendor_details;
  console.log("vendorDetails:", vendorDetails); 

  const handleManualAssign = async (isDeliveryManID) => {
    console.log("itemData:",itemData)
    console.log("deliveryBusiness:",deliveryBusiness)
    const value = {
      // customer_order_id: deliveryBusiness==="Ecommerce"?itemData?.orderDetails[0]?._id:itemData?.orderDetails[0]?._id|| null,
      vendor_action:"ASSIGN_TO_DELIVERYMAN",
      orderId: deliveryBusiness === "Ecommerce"?orderDetailId:itemData?.orderDetails[0]?.order,
      delivery_person_id: isDeliveryManID || null,
    };
    console.log("Assign value:", value);
    try {
      const res = deliveryBusiness === "Ecommerce"
        ? await OrderApi.updateOrders(value)
        : await foodOrderApi.updateOrders(value);
      console.log("delivery assign:",res);
      
      toast.success("Assign to Deliveryman Successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to assign deliveryman");
    } finally {
      setIsAssignModal(false);
      setShowManualAssign(false);
      setShowAutoAssign(false);
      fetchAllData();
      setDeliveryManID("");
      setAutoAssignRange("5");
    }
  };

  const handleAutoAssign = async () => {
    const value = {
      orderId: orderDetailId,
      vendor_action: "AUTO_ASSIGN_TO_DELIVERYMAN",
      range: autoAssignRange,
    };

    try {
      const res = await OrderApi.updateOrders(value);
      console.log("auto assign:", res);
      toast.success(res?.data?.message || "Order auto-assigned successfully");
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to auto-assign order");
    } finally {
      setIsAssignModal(false);
      setShowManualAssign(false);
      setShowAutoAssign(false);
      fetchAllData();
      setDeliveryManID("");
      setAutoAssignRange("5");
    }
  };

  return (
    <div className="w-full fixed inset-0 flex items-center justify-center bg-[#111827d9] bg-opacity-80 z-[9999]">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md sm:max-w-xl md:max-w-2xl h-[60%] flex flex-col p-5">
        {/* Header */}
        <div className="flex justify-between items-center cursor-pointer">
          <h1 className="text-xl font-bold">Assign Order</h1>
          <div
            onClick={() => setIsAssignModal(false)}
            className="text-xl font-bold hover:text-black"
          >
            X
          </div>
        </div>
        <hr className="my-4" />
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-4">

        {showManualAssign ? (
          <div>
            {/* Manual Assign Section */}
            <h2 className="text-lg font-semibold">Select Delivery Personnel</h2>
            <div className="space-y-2 mt-2">
              {allDeliveryMan&&allDeliveryMan.map((person) => (
                <label
                  key={person?.userId}
                  className="flex items-center space-x-2"
                >
                  <input
                    type="radio"
                    name="deliveryPerson"
                    value={person?._id}
                    className="form-radio"
                    onClick={() => setDeliveryManID(person?._id)}
                  />
                  <span>
                    {person?.firstName} {person?.lastName}
                  </span>
                </label>
              ))}
            </div>
          </div>
        ) : showAutoAssign ? (
          <div>
            <h2 className="text-lg font-semibold">Select Auto Assign Range</h2>
            <div className="space-y-2 mt-2">
              {["5", "10", "10+"].map((rangeOption) => (
                <label
                  key={rangeOption}
                  className="flex items-center space-x-2"
                >
                  <input
                    type="radio"
                    name="autoAssignRange"
                    value={rangeOption}
                    checked={autoAssignRange === rangeOption}
                    className="form-radio"
                    onChange={() => setAutoAssignRange(rangeOption)}
                  />
                  <span>{rangeOption} km</span>
                </label>
              ))}
            </div>
          </div>
        ) : (
          <div>
            {/* Order Details Section */}
            <div className="">
              <p>
                <strong>Order ID:</strong> {itemData?.order_id}
              </p>
              <p>
                <strong>Order Type:</strong> {itemData?.order_type}
              </p>
              <p>
                <strong>No of Orders:</strong> {itemData?.orderDetails?.length}
              </p>
              <p>
                <strong>Order Date:</strong>{" "}
                {moment(itemData.order_date).format("MMM Do, YYYY")}
              </p>
              <p>
                <strong>Delivery Address:</strong>{" "}
                {itemData.delivery_address.street},
                {itemData.delivery_address.city.name},{" "}
                {itemData.delivery_address.country.name}
              </p>
              <p>
                <strong>Order Cost:</strong>{" "}
               {formattedAmount(
                         itemData?.orderDetails?.reduce((total, detail) => {
                           const price = parseFloat(detail.price?.$numberDecimal || 0);
                           return total + price;
                         }, 0)
                       )}
              </p>
              <p>
                <strong>Payment Status:</strong> {itemData?.payment_status}
              </p>
              <p className="pt-4 font-bold text-lg">Product Details</p>
              <hr className="p-0 m-0" />
              {Array.isArray(itemData?.orderDetails) &&
                itemData.orderDetails.map((product, index) => (
                  <div className="flex items-center justify-between gap-4 mb-4 border-b" key={index}>
                    
                    <p className="border-r">
                      <strong>{index+1})</strong> {product?.product?.name}
                    </p>
                    <img
                      src={product?.product?.primary_image}
                      alt={product?.product?.name || "Product Image"}
                      height="100px"
                      width="100px"
                      className="object-cover"
                    />
                  </div>
                ))}

              <p className="pt-4 font-bold text-lg">Vendor Contacts</p>
              <hr className="p-0 m-0" />
              <p>
                <strong>Shop Name:</strong> {vendorDetails?.first_name}
              </p>
              <p>
                <strong>Contact No:</strong> {vendorDetails?.phone_number}
              </p>
              <p>
                <strong>Contact Email:</strong> {vendorDetails?.email}
              </p>
              <p className="pt-4 font-bold text-lg">Customer Contacts</p>
              <hr />
              <p>
                <strong>Ordered By:</strong> {itemData.delivery_address.name}
              </p>
              <p>
                <strong>Contact No:</strong>{" "}
                {itemData.delivery_address.phone_number}
              </p>
            </div>
          </div>
        )}
        </div>

        {/* Button Section */}
        <div className="mt-6 flex justify-center gap-2">
          {showManualAssign ? (
            <>
              <button
                className="bg-[#6B7280] text-white px-4 py-2 rounded hover:bg-[#4A5568]"
                onClick={() => {
                  setShowManualAssign(false);
                  setDeliveryManID("");
                }}
              >
                Back
              </button>
              <button
                className="bg-indigo-800 text-white px-4 py-2 rounded hover:bg-indigo-900"
                onClick={() => handleManualAssign(isDeliveryManID)}
              >
                Assign Selected
              </button>
            </>
          ) : showAutoAssign ? (
            <>
              <button
                className="bg-[#6B7280] text-white px-4 py-2 rounded hover:bg-[#4A5568]"
                onClick={() => {
                  setShowAutoAssign(false);
                  setAutoAssignRange("5");
                }}
              >
                Back
              </button>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded"
                onClick={handleAutoAssign}
              >
                Confirm Auto Assign
              </button>
            </>
          ) : (
            <>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded"
                onClick={() => {
                  setShowAutoAssign(true);
                  setShowManualAssign(false);
                }}
              >
                Auto Assign
              </button>
              <button
                className="bg-RedColor text-white px-4 py-2 rounded hover:bg-red600"
                onClick={() => {
                  setShowManualAssign(true);
                  setShowAutoAssign(false);
                }}
              >
                Manual Assign
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignOrderModal;
